import { z } from "zod";
import { toObjectMap } from "../utilities/dictionary";
import { translatableZodSchema, translation } from "./translations/translation";

const countryCodes = [
    "SE",
    "NO",
    "DK",
    "FI",
    "DE",
    "NL",
    "BE",
    "FR",
    "ES",
    "IT",
    "AT",
    "CH",
    "CZ",
    "PL",
    "GB",
    "IE",
    "PT",
    "RO",
    "SK",
    "SI",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "al",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
    "HR",
    "HU",
    "LT",
    "LV",
    "EE",
    "GR",
    "BG",
    "BA",
    "RS",
    "ME",
    "MK",
    "AL",
    "MD",
    "TR",
    "RO",
    "RS",
] as const;
type CountryCode = (typeof countryCodes)[number];
const countryCodeZodSchema = z.enum(countryCodes);
const countryCode = toObjectMap<CountryCode>([...countryCodes]);

const countryZodSchema = z.object({
    name: translatableZodSchema,
    countryCode: countryCodeZodSchema,
    callingCode: z.string(),
});
type Country = z.infer<typeof countryZodSchema>;

const countries: Country[] = [
    {
        name: translation({
            sv: "Sverige",
            en: "Sweden",
        }),
        countryCode: "SE",
        callingCode: "+46",
    },
];
export {
    countries,
    countryCode,
    countryCodes,
    countryCodeZodSchema,
    countryZodSchema,
};
export type { Country, CountryCode };
